import styled from '../../../theme/styled-with-theme';

import { GlImage } from '../../Image';

export const StyledImage = styled(GlImage)`
  max-width: 100%;
  display: block;
  margin: 0 auto;
`;
